module.exports = __webpack_public_path__ + "static/media/ic_video_on_small_transparent.1116848a.svg";